import { render, staticRenderFns } from "./variationDetails.vue?vue&type=template&id=1635d2a2&scoped=true"
import script from "./variationDetails.vue?vue&type=script&lang=js"
export * from "./variationDetails.vue?vue&type=script&lang=js"
import style0 from "./variationDetails.vue?vue&type=style&index=0&id=1635d2a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1635d2a2",
  null
  
)

export default component.exports